// extracted by mini-css-extract-plugin
module.exports = {"styledRow":"styles_styledRow__k1Z9h","styledRow__header":"styles_styledRow__header__1L8Wl","styledRow__footer":"styles_styledRow__footer__3DlSH"};